import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "columns is-multiline" }
const _hoisted_2 = { class: "column is-full" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-content" }
const _hoisted_5 = {
  key: 0,
  class: "column is-full"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "content has-text-centered" }, [
      /*#__PURE__*/_createElementVNode("p", null, "There are no results, try expanding the dates of your search")
    ])
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "column is-one-third-desktop is-full-tablet" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-header" }
const _hoisted_11 = { class: "card-header-title has-text-weight-normal" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Explore", -1)
const _hoisted_13 = { class: "card-content" }
const _hoisted_14 = { class: "card-footer" }
const _hoisted_15 = { class: "card-footer-item" }
const _hoisted_16 = { class: "content" }
const _hoisted_17 = { class: "subtitle has-text-centered has-text-metric-one" }
const _hoisted_18 = { class: "subtitle has-text-centered has-text-metric-one" }
const _hoisted_19 = { class: "card-footer-item" }
const _hoisted_20 = { class: "content" }
const _hoisted_21 = { class: "subtitle has-text-centered has-text-metric-two" }
const _hoisted_22 = { class: "subtitle has-text-centered has-text-metric-two" }

import { UseAxiosErrorHelper } from "../../Helper/ThirdParty/UseAxiosErrorHelper";
import { UseTaxonomyHelper } from "../../Helper/Stateful/UseTaxonomyHelper";
import { computed, onBeforeMount, onMounted, watch } from "vue";
import { UseUrlBuilder } from "../../Helper/Stateful/UseUrlBuilder";
import { PerformanceTableAndChartData } from "../../Helper/Stateful/PerformanceTableAndChartData";
import { storeToRefs } from "pinia";
import { UseDateStore } from "../../Modules/State/Stores/DateStore";
import { UseReportSettingsStore } from "../../Modules/State/Stores/ReportSettingsStore";
import { UseMetricHelper } from "../../Helper/Functional/UseMetricHelper";
import { UseProgramStore } from "../../Modules/State/Stores/ProgramStore";
import {
  get,
  maxBy,
  flatten,
  map,
  find,
  sumBy,
  sortBy,
  reverse,
  chunk,
  flatMapDeep,
  assign,
} from "lodash";
import { StaticChartData } from "../../StaticData/StaticChartData";
import { UseStringHelper } from "../../Helper/Functional/UseStringHelper";
import BreakdownBreadcrumb from "../../Modules/Breakdown/Breadcrumb.vue";
import BreakdownChart from "../../Modules/Breakdown/Chart.vue";
import BreakdownControls from "../../Modules/Performance/Chart/Controls.vue";
import ExportData from "../../Modules/Pieces/ExportData.vue";
import OuterSection from "../../Elements/OuterSection.vue";
import NewPagination from "../../Modules/Breakdown/NewPagination.vue";
import OrderAscDesc from "../../Modules/Pieces/OrderAscDesc.vue";
import { UseBreakdown } from "./Hooks/UseBreakdown";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

UseAxiosErrorHelper();
const chartDataType = "chart/multi";
const { validateInternalParameter } = UseStringHelper();
//Get Taxonomy

UseAxiosErrorHelper();

const {
  taxonomyOne: cpTaxonomyOne,
  taxonomyTwo: cpTaxonomyTwo,
  taxonomyThree: cpTaxonomyThree,
  currentTaxonomyInteger,
  fetchNavigationUrlHandler,
  documentTitleHandler,
  taxonomyRouteParams,
} = UseTaxonomyHelper();

taxonomyRouteParams();
const { setBasicChartUrl, buildAnyInitialUrl } = UseUrlBuilder({
  dataSet: "",
});

//Get some data?
const {
  breakdownChartData: data,
  chartLoading: loading,
  chartHeaders: headers,
  loadBreakdownChartData,
  clearBreakdownChartData,
} = PerformanceTableAndChartData();

onBeforeMount(() => {
  clearBreakdownChartData();
});

onMounted(() => {
  setBasicChartUrl(buildAnyInitialUrl("breakdown", chartDataType));
  loadBreakdownChartData();
  document.title = documentTitleHandler("Channel Breakdown");
});
const { getDateFrom, getDateTo } = storeToRefs(UseDateStore());
watch([getDateFrom, getDateTo], () => {
  setBasicChartUrl(buildAnyInitialUrl("breakdown", chartDataType));
  clearBreakdownChartData();
  loadBreakdownChartData();
});

//Metrics

const { getCurrentProgramName } = storeToRefs(UseProgramStore());
const {
  firstMetric,
  secondMetric,
  interval,
  monetaryMetrics,
  typeOfChart,
  page,
  perPage,
  sortDirection,
} = UseBreakdown();
const { getPerformanceChartInterval } = storeToRefs(UseReportSettingsStore());

const { fetchMetricValue } = UseMetricHelper();

const firstMetricMax = computed(() => {
  return get(
    maxBy(flatten(map(data.value, (x) => x.data)), firstMetric.value),
    firstMetric.value
  );
});

const secondMetricMax = computed(() => {
  return get(
    maxBy(flatten(map(data.value, (x) => x.data)), secondMetric.value),
    secondMetric.value
  );
});
watch(getPerformanceChartInterval, () => {
  setBasicChartUrl(buildAnyInitialUrl("breakdown", chartDataType));
  loadBreakdownChartData();
});

const { metricsArray: metrics } = StaticChartData();

const fetchValue = (breakdownName: string, metric: string) => {
  let breakdown = find(data.value, { name: breakdownName });

  if (!data.value || !breakdown || !firstMetric.value || !secondMetric.value) {
    return "-";
  }

  let rtn: string | number;

  switch (metric) {
    case "fixed_cost":
    case "variable_cost":
    case "total_cost":
    case "clicks":
    case "impressions":
    case "first_click_sales":
    case "last_click_sales":
    case "attributed_sales":
    case "first_click_revenue":
    case "last_click_revenue":
    case "attributed_revenue":
      rtn = sumBy(breakdown["data"], (v) => {
        return +v[metric];
      });
      break;
    case "first_click_aov":
    case "last_click_aov":
    case "attributed_aov":
      let metricPrefix =
        metric === "first_click_aov"
          ? "first_click"
          : metric === "last_click_aov"
          ? "last_click"
          : "attributed";
      let div = sumBy(breakdown["data"], function (v) {
        return v[metricPrefix + "_sales"];
      });
      rtn =
        div === 0
          ? 0
          : sumBy(breakdown["data"], function (v) {
              return v[metricPrefix + "_revenue"];
            }) / div;
      break;
    case "first_click_conversion_rate":
    case "last_click_conversion_rate":
    case "attributed_conversion_rate":
      let crMetricPrefix =
        metric === "first_click_conversion_rate"
          ? "first_click"
          : metric === "last_click_conversion_rate"
          ? "last_click"
          : "attributed";
      let fcrTotal = sumBy(breakdown["data"], (v) => {
        return +v.clicks;
      });
      rtn =
        fcrTotal === 0
          ? 0
          : (sumBy(breakdown["data"], function (v) {
              return v[crMetricPrefix + "_sales"];
            }) /
              fcrTotal) *
            100;
      break;
    case "cpa":
      rtn =
        sumBy(breakdown["data"], (v) => {
          return +v.total_cost;
        }) /
        Math.max(
          sumBy(breakdown["data"], (v) => {
            return +v.attributed_sales;
          }),
          1
        );
      break;
    case "roas":
      let total = sumBy(breakdown["data"], (v) => {
        return +v.total_cost;
      });
      rtn =
        total === 0
          ? 0
          : sumBy(breakdown["data"], (v) => {
              return +v.attributed_revenue;
            }) / total;
      break;
    case "attributed_revenue_variance_percent":
      let arTotal = sumBy(breakdown["data"], (v) => {
        return +v.attributed_revenue;
      });
      let lcrTotal = sumBy(breakdown["data"], (v) => {
        return +v.last_click_revenue;
      });
      rtn = lcrTotal !== 0 ? ((arTotal - lcrTotal) / lcrTotal) * 100 : 0;
      break;
    default:
      return "-";
  }

  return fetchMetricValue(metric, rtn);
};

const orderedData = computed(() => {
  let sorted = sortBy(data.value, function (value) {
    return sumBy(value.data, function (v) {
      return v[firstMetric.value];
    });
  });

  // Because the data is multidimensional, we have to sort by sum of total, and then reverse (or not)
  if (sortDirection.value === "asc") {
    return sorted;
  } else {
    return reverse(sorted);
  }
});
const chunkedData = computed(() => {
  return chunk(orderedData.value, perPage.value);
});
const pageData = computed(() => {
  return data.value ? chunkedData.value[page.value - 1] : [];
});
const exportedData = computed(() => {
  return flatMapDeep(data.value, (d) =>
    flatMapDeep(d.data, (inner) =>
      assign(inner, {
        name: d.name,
        first_click_conversion_rate: +inner.first_click_conversion_rate / 100,
        last_click_conversion_rate: +inner.last_click_conversion_rate / 100,
        attributed_conversion_rate: +inner.attributed_conversion_rate / 100,
        attributed_revenue_variance_percent:
          +inner.attributed_revenue_variance_percent / 100,
      })
    )
  );
});

const fetchNavigationUrl = computed(() => fetchNavigationUrlHandler("/breakdown"));

return (_ctx: any,_cache: any) => {
  const _component_o_loading = _resolveComponent("o-loading")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(OuterSection, { ref: "breakdownTaxonomyOneSection" }, {
      default: _withCtx(() => [
        _createVNode(_component_o_loading, {
          active: _unref(loading),
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null))
        }, null, 8, ["active"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(BreakdownBreadcrumb, {
                  taxonomyOne: _unref(cpTaxonomyOne),
                  taxonomyTwo: _unref(cpTaxonomyTwo),
                  taxonomyThree: _unref(cpTaxonomyThree)
                }, null, 8, ["taxonomyOne", "taxonomyTwo", "taxonomyThree"]),
                _createVNode(_component_o_field, {
                  grouped: "",
                  "group-multiline": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(BreakdownControls, {
                      headers: _unref(headers),
                      metrics: _unref(metrics),
                      "first-metric": _unref(firstMetric),
                      "onUpdate:first-metric": _cache[2] || (_cache[2] = ($event: any) => (_isRef(firstMetric) ? (firstMetric).value = $event : null)),
                      "second-metric": _unref(secondMetric),
                      "onUpdate:second-metric": _cache[3] || (_cache[3] = ($event: any) => (_isRef(secondMetric) ? (secondMetric).value = $event : null)),
                      "chart-type": _unref(typeOfChart),
                      "onUpdate:chart-type": _cache[4] || (_cache[4] = ($event: any) => (_isRef(typeOfChart) ? (typeOfChart).value = $event : null)),
                      interval: _unref(interval),
                      "onUpdate:interval": _cache[5] || (_cache[5] = ($event: any) => (_isRef(interval) ? (interval).value = $event : null)),
                      breakdown: true,
                      exportable: true
                    }, {
                      ordering: _withCtx(() => [
                        _createVNode(OrderAscDesc, {
                          "sort-direction": _unref(sortDirection),
                          "onUpdate:sort-direction": _cache[1] || (_cache[1] = ($event: any) => (_isRef(sortDirection) ? (sortDirection).value = $event : null))
                        }, null, 8, ["sort-direction"])
                      ]),
                      export: _withCtx(() => [
                        _createVNode(ExportData, {
                          "available-columns": ['conversion_date', 'name'].concat(_unref(metrics)),
                          "selected-columns": ['conversion_date', 'name'].concat(_unref(metrics)),
                          "always-selected-columns": ['conversion_date', 'name'],
                          "column-headers": 
                        _unref(assign)({ conversion_date: 'Date', name: 'Name' }, _unref(headers))
                      ,
                          "report-name": 
                        (
                          _unref(getCurrentProgramName) +
                          '_breakdown_t1_' +
                          _unref(getDateFrom) +
                          '_' +
                          _unref(getDateTo)
                        )
                          .toLowerCase()
                          .split(' ')
                          .join('_')
                      ,
                          "exportable-data": _unref(exportedData),
                          "order-data-by": ['name', 'conversion_date'],
                          "order-data-direction": ['asc', 'asc']
                        }, null, 8, ["available-columns", "selected-columns", "column-headers", "report-name", "exportable-data"])
                      ]),
                      _: 1
                    }, 8, ["headers", "metrics", "first-metric", "second-metric", "chart-type", "interval"]),
                    _createVNode(NewPagination, {
                      "per-page-options": [6, 12, 24],
                      page: _unref(page),
                      "onUpdate:page": _cache[6] || (_cache[6] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
                      "per-page": _unref(perPage),
                      "onUpdate:per-page": _cache[7] || (_cache[7] = ($event: any) => (_isRef(perPage) ? (perPage).value = $event : null)),
                      records: _unref(orderedData).length,
                      "onUpdate:records": _cache[8] || (_cache[8] = ($event: any) => ((_unref(orderedData).length) = $event))
                    }, null, 8, ["page", "per-page", "records"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          (!_unref(data).length && !_unref(loading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData), (breakdown) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("header", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(breakdown.name), 1),
                  (_unref(currentTaxonomyInteger) < 4)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `${_unref(fetchNavigationUrl)}${_unref(validateInternalParameter)(
                    breakdown.name
                  )}`,
                        class: "card-header-icon"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_o_icon, {
                            icon: "chevron-right",
                            size: "is-small"
                          }),
                          _hoisted_12
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(BreakdownChart, {
                    reference: breakdown.name,
                    headers: _unref(headers),
                    "onUpdate:headers": _cache[9] || (_cache[9] = ($event: any) => (_isRef(headers) ? (headers).value = $event : null)),
                    "type-of-chart": _unref(typeOfChart),
                    "onUpdate:type-of-chart": _cache[10] || (_cache[10] = ($event: any) => (_isRef(typeOfChart) ? (typeOfChart).value = $event : null)),
                    "first-metric": _unref(firstMetric),
                    "onUpdate:first-metric": _cache[11] || (_cache[11] = ($event: any) => (_isRef(firstMetric) ? (firstMetric).value = $event : null)),
                    "first-metric-max": _unref(firstMetricMax),
                    "onUpdate:first-metric-max": _cache[12] || (_cache[12] = ($event: any) => (_isRef(firstMetricMax) ? (firstMetricMax).value = $event : null)),
                    "second-metric": _unref(secondMetric),
                    "onUpdate:second-metric": _cache[13] || (_cache[13] = ($event: any) => (_isRef(secondMetric) ? (secondMetric).value = $event : null)),
                    "second-metric-max": _unref(secondMetricMax),
                    "onUpdate:second-metric-max": _cache[14] || (_cache[14] = ($event: any) => (_isRef(secondMetricMax) ? (secondMetricMax).value = $event : null)),
                    "monetary-metrics": _unref(monetaryMetrics),
                    data: breakdown.data,
                    "onUpdate:data": ($event: any) => ((breakdown.data) = $event)
                  }, null, 8, ["reference", "headers", "type-of-chart", "first-metric", "first-metric-max", "second-metric", "second-metric-max", "monetary-metrics", "data", "onUpdate:data"])
                ]),
                _createElementVNode("footer", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(headers)[_unref(firstMetric)] || _unref(firstMetric)), 1),
                      _createElementVNode("p", _hoisted_18, _toDisplayString(fetchValue(breakdown.name, _unref(firstMetric))), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(headers)[_unref(secondMetric)] || _unref(secondMetric)), 1),
                      _createElementVNode("p", _hoisted_22, _toDisplayString(fetchValue(breakdown.name, _unref(secondMetric))), 1)
                    ])
                  ])
                ])
              ])
            ]))
          }), 256))
        ])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})